'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _plugin = require('../../plugin');
var _plugin2 = _interopRequireDefault(_plugin);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var INITIAL_LAST_TIMESTAMP = 0;
var LastTimestampHandler = function (_Plugin) {
  _inherits(LastTimestampHandler, _Plugin);
  function LastTimestampHandler(entity) {
    _classCallCheck(this, LastTimestampHandler);
    var _this = _possibleConstructorReturn(this, (LastTimestampHandler.__proto__ || Object.getPrototypeOf(LastTimestampHandler)).call(this, entity));
    _this.lastTimestamp = INITIAL_LAST_TIMESTAMP;
    return _this;
  }
  _createClass(LastTimestampHandler, [{
    key: 'updateFromMicrosecondTimestamp',
    value: function updateFromMicrosecondTimestamp(timestamp) {
      this._update(Math.trunc(timestamp / 1000));
    }
  }, {
    key: 'updateFromIsoDate',
    value: function updateFromIsoDate(isoDate) {
      this._update(new Date(isoDate).getTime());
    }
  }, {
    key: 'getDate',
    value: function getDate() {
      if (this.lastTimestamp !== 0) {
        return new Date(this.lastTimestamp).toISOString();
      }
      return undefined;
    }
  }, {
    key: '_update',
    value: function _update(timestamp) {
      this.lastTimestamp = Math.max(this.lastTimestamp, timestamp);
    }
  }, {
    key: 'clear',
    value: function clear() {
      this.lastTimestamp = INITIAL_LAST_TIMESTAMP;
    }
  }]);
  return LastTimestampHandler;
}(_plugin2.default);
LastTimestampHandler.pluginName = 'lastTimestampHandler';
exports.default = LastTimestampHandler;